import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { appConstants } from '../../app-constants';
import { GenericType } from '../../shared/models/codes/generic-type.model';
import { ErrorResponse } from '../models/error-response.model';

@Injectable({
	providedIn: 'root',
})
export class UtilsService {
	constructor() {}

	getPaginationParams(pageSize: number, currentPage: number): HttpParams {
		let params = new HttpParams();

		params = params.append(appConstants.QUERY_PARAMS.PAGE_SIZE, pageSize.toString());
		params = params.append(appConstants.QUERY_PARAMS.CURRENT_PAGE, currentPage.toString());

		return params;
	}

	buildErrorModel(error: HttpErrorResponse): ErrorResponse {
		return {
			...error?.error,
			status: error?.status,
			httpResponse: error,
		};
	}

	buildGenericTypeModel(type: GenericType): GenericType {
		return {
			...type,
			value: parseInt(type.value.toString(), 10),
		};
	}

	formatDate(date: string | Date): string {
		const localDate = new Date(
			new Date(date).getTime() - new Date().getTimezoneOffset() * 60000
		);

		return moment(localDate).format(appConstants.DISPLAY_DATE);
		return moment(date).format(appConstants.DISPLAY_DATE);
	}

	formatDecimal(decimal: number): string {
		return decimal
			.toLocaleString(undefined, {
				style: 'decimal',
				maximumFractionDigits: 2,
				minimumFractionDigits: 2,
			})
			.replace(/,/g, '');
	}

	buildHttpParamsFromAny(filter: any): HttpParams {
		let params = new HttpParams();

		for (const key of Object.keys(filter)) {
			if (filter[key] !== undefined && filter[key] !== null && filter[key] !== '') {
				if (Array.isArray(filter[key])) {
					for (const item of filter[key]) {
						params = params.append(key.charAt(0).toUpperCase() + key.slice(1), item);
					}
				} else {
					params = params.append(key.charAt(0).toUpperCase() + key.slice(1), filter[key]);
				}
			}
		}

		return params;
	}

	isValueTruthy(value: any): boolean {
		return value !== undefined && value !== null && value.toString() !== '';
	}
}
